import * as evidenceChoiceIntro from '../../shared/pages/evidenceChoiceIntroPage';
import * as evidenceChoiceAdditionalDocumentsV1 from './supportingEvidenceEnhancement/evidenceChoiceAdditionalDocumentsPageV1';
import * as adaptiveBenefits from './adaptiveBenefits';
import * as additionalBehaviorChanges from './additionalBehaviorChanges';
import * as additionalDocuments from './additionalDocuments';
import * as additionalExposures from './toxicExposure/additionalExposures';
import * as additionalExposuresDetails from './toxicExposure/additionalExposuresDetails';
import * as additionalExposuresSummary from './toxicExposure/additionalExposuresSummary';
import * as additionalRemarks781 from './additionalRemarks781';
import * as aidAndAttendance from './aidAndAttendance';
import * as alternateNames from './alternateNames';
import * as ancillaryFormsWizardSummary from './ancillaryFormsWizardSummary';
import * as choosePtsdType from './choosePtsdType';
import * as claimExamsInfo from '../../shared/pages/claimExamsInfo';
import * as claimType from './claimType';
import * as contactInformation from './contactInformation';
import * as employmentHistory from './employmentHistory';
import * as evidenceRequest from './evidenceRequest';
import * as evidenceTypes from './evidenceTypes';
import * as evidenceTypesBDD from './evidenceTypesBDD';
import * as federalOrders from './federalOrders';
import * as finalIncident from './finalIncident';
import * as fullyDevelopedClaim from './fullyDevelopedClaim';
import * as gulfWar1990Locations from './toxicExposure/gulfWar1990Locations';
import * as gulfWar1990Details from './toxicExposure/gulfWar1990Details';
import * as gulfWar1990Summary from './toxicExposure/gulfWar1990Summary';
import * as gulfWar2001Locations from './toxicExposure/gulfWar2001Locations';
import * as gulfWar2001Details from './toxicExposure/gulfWar2001Details';
import * as gulfWar2001Summary from './toxicExposure/gulfWar2001Summary';
import * as herbicideLocations from './toxicExposure/herbicideLocations';
import * as herbicideDetails from './toxicExposure/herbicideDetails';
import * as herbicideOtherLocations from './toxicExposure/herbicideOtherLocations';
import * as herbicideSummary from './toxicExposure/herbicideSummary';
import * as homelessOrAtRisk from './homelessOrAtRisk';
import * as hospitalizationHistory from './hospitalizationHistory';
import * as incidentDate from './incidentDate';
import * as incidentDescription from './incidentDescription';
import * as incidentLocation from './incidentLocation';
import * as incidentSupport from './incidentSupport';
import * as incidentUnitAssignment from './incidentUnitAssignment';
import * as incomeDetails from './incomeDetails';
import * as individualsInvolvedFollowUp from './individualsInvolvedFollowUp';
import * as individualsInvolved from './individualsInvolved';
import * as individualUnemployability from './individualUnemployability';
import * as instructionalPart1 from './instructionalPart1';
import * as instructionalPart2 from './instructionalPart2';
import * as instructionalPart3 from './instructionalPart3';
import * as medals from './medals';
import * as medicalCare from './medicalCare';
import * as medicalRecords from './medicalRecords';
import * as mentalHealthChanges from './mentalHealthChanges';
import * as militaryDutyImpact from './militaryDutyImpact';
import * as militaryHistory from './militaryHistory';
import * as newDisabilityFollowUp from './newDisabilityFollowUp';
import * as newPTSDFollowUp from './newPTSDFollowUp';
import * as pastEducationTraining from './pastEducationTraining';
import * as pastEmploymentFormDownload from './pastEmploymentFormDownload';
import * as pastEmploymentFormIntro from './pastEmploymentFormIntro';
import * as pastEmploymentFormUpload from './pastEmploymentFormUpload';
import * as paymentInformation from './paymentInformation';
import * as physicalHealthChanges from './physicalHealthChanges';
import * as prisonerOfWar from './prisonerOfWar';
import * as privateMedicalRecords from './privateMedicalRecords';
import * as privateMedicalRecordsUpload from './supportingEvidenceEnhancement/privateMedicalRecordsUpload';
import * as privateMedicalRecordsUploadV1 from './supportingEvidenceEnhancement/privateMedicalRecordsUploadV1';
import * as privateMedicalRecordsAttachments from './privateMedicalRecordsAttachments';
import * as privateMedicalAuthorizeRelease from './privateMedicalAuthorizeRelease';
import * as privateMedicalRecordsRelease from './privateMedicalRecordsRelease';
import * as ptsd781aChangesIntro from './ptsd781aChangesIntro';
import * as ptsdAdditionalEvents from './ptsdAdditionalEvents';
import * as ptsdBypassCombat from './ptsdBypassCombat';
import * as ptsdBypassNonCombat from './ptsdBypassNonCombat';
import * as ptsdSecondaryAdditionalEvents from './ptsdSecondaryAdditionalEvents';
import * as ptsdWalkthroughChoice781a from './ptsdWalkthroughChoice781a';
import * as ptsdWalkthroughChoice781 from './ptsdWalkthroughChoice781';
import * as ratedDisabilities from './ratedDisabilities';
import * as recentEarnedIncome from './recentEarnedIncome';
import * as recentEducationTraining from './recentEducationTraining';
import * as recentJobApplications from './recentJobApplications';
import * as reservesNationalGuardService from './reservesNationalGuardService';
import * as retirementPay from './retirementPay';
import * as retirementPayWaiver from './retirementPayWaiver';
import * as secondaryFinalIncident from './secondaryFinalIncident';
import * as separationHealthAssessment from './separationHealthAssessment';
import * as separationHealthAssessmentUpload from './separationHealthAssessmentUpload';
import * as separationHealthAssessmentUploadV1 from './separationHealthAssessmentUploadV1';
import * as secondaryIncidentAuthorities from './secondaryIncidentAuthorities';
import * as secondaryIncidentDate from './secondaryIncidentDate';
import * as secondaryIncidentDescription from './secondaryIncidentDescription';
import * as secondaryIncidentLocation from './secondaryIncidentLocation';
import * as secondaryIncidentPermissionNotice from './secondaryIncidentPermissionNotice';
import * as secondaryIncidentUnitAssignment from './secondaryIncidentUnitAssignment';
import * as secondaryOtherSources from './secondaryOtherSources';
import * as secondaryOtherSourcesHelp from './secondaryOtherSourcesHelp';
import * as secondaryUploadSourcesChoice from './secondaryUploadSourcesChoice';
import * as secondaryUploadSources from './secondaryUploadSources';
import * as separationLocation from './separationLocation';
import * as separationPay from './separationPay';
import * as serviceTreatmentRecords from './serviceTreatmentRecords';
import * as serviceTreatmentRecordsAttachments from './serviceTreatmentRecordsAttachments';
import * as serviceTreatmentRecordsAttachmentsV3 from './serviceTreatmentRecordsAttachmentsV3';
import * as socialBehaviorChanges from './socialBehaviorChanges';
import * as specifyOtherExposures from './toxicExposure/specifyOtherExposures';
import * as summaryOfDisabilities from './summaryOfDisabilities';
import * as summaryOfEvidence from './summaryOfEvidence';
import * as supplementalBenefits from './supplementalBenefits';
import * as terminallyIll from './terminallyIll';
import * as toxicExposureConditions from './toxicExposure/toxicExposureConditions';
import * as trainingPay from './trainingPay';
import * as trainingPayWaiver from './trainingPayWaiver';
import * as unemployabilityAdditionalInformation from './unemployabilityAdditionalInformation';
import * as unemployabilityCertification from './unemployabilityCertification';
import * as unemployabilityDates from './unemployabilityDates';
import * as unemployabilityDisabilities from './unemployabilityDisabilities';
import * as unemployabilityDoctorCare from './unemployabilityDoctorCare';
import * as unemployabilityFormIntro from './unemployabilityFormIntro';
import * as unemployabilityFormUpload from './unemployabilityFormUpload';
import * as uploadPersonalPtsdDocuments from './uploadPersonalPtsdDocuments';
import * as uploadPtsdDocuments from './uploadPtsdDocuments';
import * as uploadUnemployabilitySupportingDocumentsChoice from './uploadUnemployabilitySupportingDocumentsChoice';
import * as uploadUnemployabilitySupportingDocuments from './uploadUnemployabilitySupportingDocuments';
import * as vaEmployee from './vaEmployee';
import * as vaMedicalRecords from './vaMedicalRecords';
import * as veteranInfo from './veteranInfo';
import * as workBehaviorChanges from './workBehaviorChanges';
import * as addDisabilities from './addDisabilities';

export {
  adaptiveBenefits,
  addDisabilities,
  additionalBehaviorChanges,
  additionalDocuments,
  additionalExposures,
  additionalExposuresDetails,
  additionalExposuresSummary,
  additionalRemarks781,
  aidAndAttendance,
  alternateNames,
  ancillaryFormsWizardSummary,
  choosePtsdType,
  claimExamsInfo,
  claimType,
  contactInformation,
  employmentHistory,
  evidenceRequest,
  evidenceTypes,
  evidenceTypesBDD,
  evidenceChoiceIntro,
  evidenceChoiceAdditionalDocumentsV1,
  federalOrders,
  finalIncident,
  fullyDevelopedClaim,
  gulfWar1990Locations,
  gulfWar1990Details,
  gulfWar1990Summary,
  gulfWar2001Locations,
  gulfWar2001Details,
  gulfWar2001Summary,
  herbicideLocations,
  herbicideDetails,
  herbicideOtherLocations,
  herbicideSummary,
  homelessOrAtRisk,
  hospitalizationHistory,
  incidentDate,
  incidentDescription,
  incidentLocation,
  incidentSupport,
  incidentUnitAssignment,
  incomeDetails,
  individualsInvolved,
  individualsInvolvedFollowUp,
  individualUnemployability,
  instructionalPart1,
  instructionalPart2,
  instructionalPart3,
  medals,
  medicalCare,
  medicalRecords,
  mentalHealthChanges,
  militaryDutyImpact,
  militaryHistory,
  newDisabilityFollowUp,
  newPTSDFollowUp,
  pastEducationTraining,
  pastEmploymentFormIntro,
  pastEmploymentFormDownload,
  pastEmploymentFormUpload,
  paymentInformation,
  physicalHealthChanges,
  prisonerOfWar,
  privateMedicalRecords,
  privateMedicalRecordsUpload,
  privateMedicalRecordsUploadV1,
  privateMedicalRecordsAttachments,
  privateMedicalAuthorizeRelease,
  privateMedicalRecordsRelease,
  ptsd781aChangesIntro,
  ptsdAdditionalEvents,
  ptsdBypassCombat,
  ptsdBypassNonCombat,
  ptsdSecondaryAdditionalEvents,
  ptsdWalkthroughChoice781,
  ptsdWalkthroughChoice781a,
  ratedDisabilities,
  recentEarnedIncome,
  recentEducationTraining,
  recentJobApplications,
  reservesNationalGuardService,
  retirementPay,
  retirementPayWaiver,
  secondaryFinalIncident,
  separationHealthAssessment,
  separationHealthAssessmentUpload,
  separationHealthAssessmentUploadV1,
  secondaryIncidentAuthorities,
  secondaryIncidentDate,
  secondaryIncidentDescription,
  secondaryIncidentLocation,
  secondaryIncidentPermissionNotice,
  secondaryIncidentUnitAssignment,
  secondaryOtherSources,
  secondaryOtherSourcesHelp,
  secondaryUploadSources,
  secondaryUploadSourcesChoice,
  separationLocation,
  separationPay,
  serviceTreatmentRecords,
  serviceTreatmentRecordsAttachments,
  serviceTreatmentRecordsAttachmentsV3,
  socialBehaviorChanges,
  specifyOtherExposures,
  summaryOfDisabilities,
  summaryOfEvidence,
  supplementalBenefits,
  terminallyIll,
  toxicExposureConditions,
  trainingPay,
  trainingPayWaiver,
  unemployabilityAdditionalInformation,
  unemployabilityCertification,
  unemployabilityDates,
  unemployabilityDisabilities,
  unemployabilityDoctorCare,
  unemployabilityFormIntro,
  unemployabilityFormUpload,
  uploadPersonalPtsdDocuments,
  uploadPtsdDocuments,
  uploadUnemployabilitySupportingDocuments,
  uploadUnemployabilitySupportingDocumentsChoice,
  vaEmployee,
  vaMedicalRecords,
  veteranInfo,
  workBehaviorChanges,
};
